const myDom = {
    lines: {
        text: "normal",
        align: "center",
        baseline: "middle",
        rotation: "0",
        font: "Verdana",
        weight: "bold",
        placement: "line",
        maxangle: "1.570796327",
        overflow: "false",
        size: "12px",
        height: "1",
        offsetX: "0",
        offsetY: "0",
        color: "#2b378b",
        outline: "#f6f6f6",
        outlineWidth: "2",
        maxreso: 1,
    },
    points: {
        text: "normal",
        align: "start", // center / end / left / right / start
        baseline: "middle", // alphabetic / bottom / hanging / ideographic / middle / top
        rotation: "0", // 0 / 0.785398164 / 1.570796327
        font: "Verdana", // Arial / Courier New / Open Sans / Verdana
        weight: "normal", // normal / bold
        size: "11px",
        height: "1",
        offsetX: "8",
        offsetY: "8",
        color: "#201370",
        outline: "#c1c1c1",
        outlineWidth: "2",
        maxreso: 1,
    },
    polygons: {
        text: "normal",
        align: "center", // center / end / left / right / start
        baseline: "middle", // alphabetic / bottom / hanging / ideographic / middle / top
        rotation: "0", // 0 / 0.785398164 / 1.570796327
        font: "Verdana", // Arial / Courier New / Open Sans / Verdana
        weight: "normal", // normal / bold
        placement: "point", // point / line
        maxangle: "0.7853981633974483", // 0.7853981633974483 / 2.0943951023931953 / 6.283185307179586
        overflow: "false", // true / false
        size: "12px",
        height: "1",
        offsetX: "0",
        offsetY: "0",
        color: "#333333",
        outline: "#c1c1c1",
        outlineWidth: "2",
        maxreso: 1,
    },
};

export { myDom };
